var N = /* @__PURE__ */ ((n) => (n.NONE = "none", n.BUTTON_ALIGN_LEFT = "btn-alignment-left", n.BUTTON_ALIGN_CENTER = "btn-alignment-center", n.BUTTON_ALIGN_RIGHT = "btn-alignment-right", n))(N || {});
export {
  N as CTABtnType
};
//# sourceMappingURL=enum.js.map
